export default __webpack_public_path__ + "static/media/Expert-new.e762a19c.png";